import {
  BrandMappingInterface,
  BrandsInterface,
  BrandValidationFieldInterface,
  BrandValidationInterface,
} from '../../interfaces/brands/brands-interface';

export class BrandsClass implements BrandsInterface {
  Id = '';
  IsActive = true;
  LogoUrl = '';
  Mappings: BrandMappingInterface[] = [];
  Name = '';

  validation: BrandValidation = new BrandValidation();

  constructor(data?: any) {
    if (data) {
      this.Id = data.Id;
      this.IsActive = data.IsActive;
      this.LogoUrl = data.LogoUrl;
      this.Mappings = data.Mappings;
      this.Name = data.Name;
    }
  }

  brandNameValidation = () => {
    const validationName = this.validation.Name;

    if (this.Name?.length === 0 || !this.Name) {
      validationName.Status = true;
      validationName.Message = 'Lütfen marka ismi giriniz*';
    } else {
      validationName.Status = false;
      validationName.Message = '';
    }
  };
}

class BrandValidation implements BrandValidationInterface {
  Name: BrandValidationFieldInterface = {
    Message: '',
    Status: false,
  };
}
